if (!customElements.get('mhl-release-schedule')) {
  customElements.define('mhl-release-schedule', class extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.filters = this.querySelector('.mhl-release-schedule__filters');
      this.jumpNav = this.querySelector('.mhl-release-schedule__jump-nav');
      this.grid = this.querySelector('.mhl-release-schedule__grid');
      this.status = this.querySelector('.mhl-release-schedule__status');
      try {
        // Aggregate every page before enabling filters, so no date hides on another page.
        const fragments = [];
        for (let page = 1; page <= Number(this.dataset.pages); page++) {
          if (page === Number(this.dataset.page)) continue;
          const url = new URL(this.dataset.collectionUrl, location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('page', page);
          const response = await fetch(url);
          if (!response.ok) throw new Error('Unable to load schedule');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const schedule = document.querySelector('mhl-release-schedule');
          if (!schedule) throw new Error('Missing schedule');
          fragments.push(...schedule.querySelectorAll('.mhl-release-schedule__item'));
        }
        if (!this.isConnected) return;
        this.grid.append(...fragments);
        this.items = [...this.grid.querySelectorAll('.mhl-release-schedule__item')];
        if (!this.items.length) return;
        this.items.sort((a, b) =>
          (a.dataset.releaseDate || '9999').localeCompare(b.dataset.releaseDate || '9999') ||
          (a.dataset.releaseCategory || 'fashion').localeCompare(b.dataset.releaseCategory || 'fashion')
        );
        const dates = [...new Set(this.items.map(item => item.dataset.releaseDate).filter(Boolean))].sort();
        const showYear = new Set(dates.map(date => date.slice(0, 4))).size > 1;
        this.headings = [];
        let previousGroup = '';
        for (const item of this.items) {
          const date = item.dataset.releaseDate;
          const category = item.dataset.releaseCategory || 'fashion';
          const group = `${date}:${category}`;
          if (group !== previousGroup) {
            const row = document.createElement('li');
            row.className = 'mhl-release-schedule__group-title grid__item';
            row.setAttribute('role', 'presentation');
            const heading = document.createElement('h2');
            heading.className = 'mhl-release-schedule__heading';
            heading.setAttribute('tabindex', '-1');
            row.append(heading);
            const categories = new Set(this.items.filter(other => other.dataset.releaseDate === date).map(other => other.dataset.releaseCategory || 'fashion'));
            this.headings.push({ row, heading, date, category, mixed: categories.size > 1 });
            this.grid.append(row);
            previousGroup = group;
          }
          this.grid.append(item);
        }
        this.showYear = showYear;
        const choices = [['all', 'すべて'], ...dates.map(date => [date, this.formatDate(date)])];
        if (this.items.some(item => !item.dataset.releaseDate)) choices.push(['undated', '販売日未定']);
        for (const [value, label] of choices) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'mhl-release-schedule__filter';
          button.dataset.date = value;
          button.textContent = label;
          button.addEventListener('click', () => this.select(value));
          this.filters.append(button);
        }
        this.querySelector('.mhl-release-schedule__pagination')?.setAttribute('hidden', '');
        this.select('all');
        this.filters.hidden = false;
      } catch (error) {
        // Keep the server-rendered grid and pagination usable if another page fails.
        this.status.textContent = '日付の絞り込みを読み込めませんでした。商品一覧をご覧ください。';
      }
    }

    formatDate(date) {
      const [year, month, day] = date.split('-');
      return `${this.showYear ? `${year}年` : ''}${Number(month)}月${Number(day)}日`;
    }

    select(date) {
      let count = 0;
      for (const item of this.items) {
        const matches = date === 'all' || (date === 'undated' ? !item.dataset.releaseDate : item.dataset.releaseDate === date);
        item.hidden = !matches;
        if (matches) count++;
      }
      for (const group of this.headings) {
        const matches = date === 'all' || (date === 'undated' ? !group.date : group.date === date);
        group.row.hidden = !matches || (date !== 'all' && !group.mixed);
        const dateLabel = group.date ? this.formatDate(group.date) : '販売日未定';
        const categoryLabel = group.category === 'interior' ? 'INTERIOR' : 'FASHION';
        group.heading.textContent = group.mixed ? categoryLabel : dateLabel;
      }
      if (this.jumpNav) {
        this.jumpNav.replaceChildren();
        const targets = ['fashion', 'interior'].map(category => this.headings.find(group => group.category === category && !group.row.hidden)).filter(Boolean);
        this.jumpNav.hidden = targets.length < 2;
        if (!this.jumpNav.hidden) {
          for (const target of targets) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'mhl-release-schedule__jump';
            button.textContent = target.category.toUpperCase();
            button.addEventListener('click', () => {
              target.heading.focus({ preventScroll: true });
              target.heading.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
            });
            this.jumpNav.append(button);
          }
        }
      }
      let label = '';
      for (const button of this.filters.children) {
        const active = button.dataset.date === date;
        button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('mhl-release-schedule__filter--active', active);
        if (active) label = button.textContent;
      }
      const statusLabel = date === 'all' || date === 'undated' ? label : `${label}発売予定`;
      this.status.textContent = `${statusLabel}：${count}点`;
    }
  });
}
